import { GeographicBoundariesTable } from "@/features/service-areas/geographic-boundaries-table";

export function GeographicBoundariesScreen() {
  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Geographic Boundaries</h1>
        <p className="text-gray-600 mt-2">
          Manage geographic boundary definitions
        </p>
      </div>
      <GeographicBoundariesTable />
    </div>
  );
}
